module.exports = __webpack_public_path__ + "img/gvn_log.d0289dc0.png";